export const SET = "containers/Addressbook/SET"
export const REQUEST_CREATE = "containers/Addressbook/REQUEST_CREATE"
export const RECEIVE_CREATE = "containers/Addressbook/RECEIVE_CREATE"
export const REQUEST_UPDATE = "containers/Addressbook/REQUEST_UPDATE"
export const RECEIVE_UPDATE = "containers/Addressbook/RECEIVE_UPDATE"
export const REQUEST_DELETE = "containers/Addressbook/REQUEST_DELETE"
export const RECEIVE_DELETE = "containers/Addressbook/RECEIVE_DELETE"
export const REQUEST_IMPORT = "containers/Addressbook/REQUEST_IMPORT"
export const RECEIVE_IMPORT = "containers/Addressbook/RECEIVE_IMPORT"